export default __webpack_public_path__ + "static/media/icon4.cb2b1412.svg";